<script setup>

import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import HelpButton from "@/components/global-themed/buttons/HelpButton.vue";
import BacklinkActions from "@/components/backlinks/partials/BacklinkActions.vue";
import BacklinkTable from "@/components/backlinks/partials/BacklinkTable.vue";
import BacklinkTabs from "@/components/backlinks/partials/BacklinkTabs.vue";

const props = defineProps({
  tab: {
    type: [String, undefined],
    required: false,
    default: undefined,
  }
})

const store = useStore();

const activeTab = computed(() => store.getters['backlinks/activeTab']);

onMounted(() => {
  if (props.tab) {
    store.dispatch('backlinks/setActiveTab', props.tab)
  }
})

</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-8">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex tw-space-x-8 tw-items-center">
          <h1 class="tw-text-4.5xl tw-text-font-primary tw-font-bold tw-font-sans">
            Your Backlinks
          </h1>
        </div>
        <HelpButton
          video-url="https://player.vimeo.com/video/974032928?h=887757a97f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        />
      </div>

      <div class="tw-flex tw-gap-8">
        <div class="tw-w-full tw-flex tw-flex-col tw-gap-8">
          <div class="tw-bg-white tw-rounded-lg">
            <div class="tw-p-8 tw-pb-4">
              <BacklinkTabs />

              <BacklinkActions v-if="activeTab !== 'authority'" />

              <BacklinkTable />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
